import CryptoJS from 'crypto-js'; // 插件用于对密码做AES加密

// 取长度为16的字符串作为秘钥，不足16在末尾补0，超出截取
function lengthSlice(key) {
  let stringKey = String(key);
  if (stringKey.length > 16) {
    return stringKey.slice(1, 17);
  }
  while (stringKey.length < 16) {
    stringKey = stringKey + '0';
  }
  return stringKey;
}

// 加密
export function Encrypt(word, key) {
  if (!word || !key) {
    return '';
  }
  const parseKey = CryptoJS.enc.Utf8.parse(lengthSlice(key));
  const srcs = CryptoJS.enc.Utf8.parse(word);
  const encrypted = CryptoJS.AES.encrypt(srcs, parseKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString();
}

// 解密
export function Decrypt(word, key) {
  if (!word || !key) {
    return '';
  }
  const encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  const parseKey = CryptoJS.enc.Utf8.parse(lengthSlice(key));
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(srcs, parseKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}
